import { IStairConfig, IStepGeometry } from '@stair-craft/common/util';

/**
 * Steps along +Z, the convention shared by the straight stair and flight 1 of the
 * L/U turns. `count` straight treads start one riser above the floor.
 */
export function generateFlightSteps(count: number, riserHeight: number, treadDepth: number, config: IStairConfig): IStepGeometry[] {
    const steps: IStepGeometry[] = [];
    for (let i: number = 0; i < count; i++) {
        steps.push({
            index: i,
            position: { x: 0, y: (i + 1) * riserHeight, z: i * treadDepth },
            treadWidth: config.stairWidth,
            treadThickness: config.treadThickness,
            noseLength: config.noseLength,
            rotation: 0,
            isWinder: false,
            isLanding: false,
            treadDepth,
            riserHeight,
        });
    }
    return steps;
}
